export default "../Media/dr.kahl-dr.koch-metz-logo.svg";